import * as Yup from "yup";
export const tenantFieldConfig = [
  {
    label: "Name",
    placeholder: "Enter name",
    type: "text",
    name: "tenant_name",
  },
  {
    label: "Unit",
    placeholder: "Select Unit",
    type: "select",
    name: "unit",
    options: [
      { value: "1A", label: "1A" },
      { value: "1B", label: "1B" },
      { value: "2A", label: "2A" },
      { value: "2B", label: "2B" },
      { value: "3A", label: "3A" },
      { value: "3B", label: "3B" },
    ],
  },
  {
    label: "Email",
    placeholder: "Enter Tenant's Email",
    type: "email",
    name: "tenant_email",
  },
];

export const familyMemberFieldConfig = [
  {
    label: "Name",
    placeholder: "Enter name",
    type: "text",
    name: "name",
  },
  {
    label: "Family Members Email",
    placeholder: "Enter Family Members Email",
    type: "email",
    name: "email",
  },
];
export const propertyFieldConfig = [
  {
    label: "Property Name",
    placeholder: "Enter name",
    type: "text",
    name: "name",
  },
  {
    label: "Street Address",
    placeholder: "Enter street address",
    type: "text",
    name: "street_address",
  },
  {
    label: "State",
    placeholder: "Select state",
    type: "select",
    name: "state",
    options: [
      { value: "ny", label: "New York" },
      // { value: "ca", label: "California" },
      // { value: "tx", label: "Texas" },
      // { value: "fl", label: "Florida" },
      // { value: "il", label: "Illinois" },
      // { value: "pa", label: "Pennsylvania" },
    ],
  },
  {
    label: "Property Type",
    placeholder: "Select type",
    type: "select",
    name: "property_type",
    options: [
      {
        value: "Single Family",
        label: "Single Family",
      },
      {
        value: "Duplex (2 Units)",
        label: "Duplex (2 Units)",
      },
      {
        value: "Triplex (3 Units)",
        label: "Triplex (3 Units)",
      },
      {
        value: "Quadruplex (4 Units) ",
        label: "Quadruplex (4 Units) ",
      },
      {
        value: "Apartment (5+ Units)",
        label: "Apartment (5+ Units)",
      },
      {
        value: "Commercial Building",
        label: "Commercial Building",
      },
    ],
  },

  {
    label: "City",
    placeholder: "Enter city",
    type: "text",
    name: "city",
  },
  {
    label: "ZIP",
    placeholder: "Enter ZIP code",
    type: "text",
    name: "zip_code",
  },
];
export const tenantFieldConfigPropertyDetails = [
  {
    label: "Unit",
    placeholder: "Unit",
    type: "text",
    name: "unit",
  },
  {
    label: "Tenant's Email",
    placeholder: "Email",
    type: "email",
    name: "email",
  },
];

// New: Family member display fields for Property Details page
export const familyMemberFieldConfigPropertyDetails = [
  {
    label: "Name",
    placeholder: "Name",
    type: "text",
    name: "name",
  },
  {
    label: "Phone Number",
    placeholder: "Phone Number",
    type: "text",
    name: "phone",
  },
  {
    label: "Email",
    placeholder: "Email",
    type: "email",
    name: "email",
  },
  {
    label: "Unit",
    placeholder: "Unit",
    type: "text",
    name: "unit_apt",
  },
];

export const createValidationSchemaProperties = (
  isEditMode = false,
  accountType = "LANDLORD"
) => {
  const schemaFields = {};

  // Property fields validation
  propertyFieldConfig.forEach((field) => {
    if (field.name === "name") {
      schemaFields[field.name] = Yup.string()
        .trim()
        .required("Property name is required");
    } else if (field.name === "property_type") {
      schemaFields[field.name] = Yup.string().required(
        "Property type is required"
      );
    } else if (field.name === "street_address") {
      schemaFields[field.name] = Yup.string()
        .trim()
        .required("Street address is required");
    } else if (field.name === "city") {
      schemaFields[field.name] = Yup.string().required("City is required");
    } else if (field.name === "state") {
      schemaFields[field.name] = Yup.string().required("State is required");
    } else if (field.name === "zip_code") {
      schemaFields[field.name] = Yup.string()
        .trim()
        .required("ZIP code is required")
        .matches(/^\d{5}(-\d{4})?$/, "Invalid ZIP code format");
    }
  });

  // Units validation (array of strings) - Only for LANDLORD in Add Mode
  if (["LANDLORD", "PROPERTY_MANAGER"].includes(accountType) && !isEditMode) {
    schemaFields["units"] = Yup.array()
      .of(Yup.string().trim().required("Unit name is required"))
      .min(1, "At least one unit is required");
  }

  // Add validation for edit unit fields when in edit mode
  // if (isEditMode) {
  //   schemaFields["selectedUnitToEdit"] = Yup.string().required(
  //     "Please select a unit to edit"
  //   );

  //   schemaFields["newUnitName"] = Yup.string()
  //     .trim()
  //     .required("New unit name is required")
  //     .min(1, "Unit name cannot be empty");
  // }

  return Yup.object().shape(schemaFields);
};
